ActionNames = require './ActionNames'
Storage = require '../lib/Storage'

module.exports = (store) -> (next) -> (action) ->
	# Load games from storage and add to GamesLoaded action
	if action.type is ActionNames.GamesLoaded
		action.games = action.games.concat Storage.getGames()

	# Process action
	result = next action

	# Store result
	games = (g for id, g of store.getState().gamesById)
	Storage.storeGames games
	
	result